import { post } from '../../../helpers/axios';

const BASE_PATH = '/auth';

export const recoverPassword = (email) => post(`${BASE_PATH}/recover-password`, { email });